require('./eventsWidget.style.scss');

const TIME_STEP = 1000 * 60 * 60 * 8; //8h
class EventsWidgetController {
    constructor($scope, $filter, $rootScope, styleService, dashboardService, sharedPersistenceService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.dateFilter = $filter('localizeDate');
        this._dashboardService = dashboardService;
        this.ENDPOINT = sharedPersistenceService.getRestEndpoints().EVENTS_REST;
        this.graphColors = styleService.getGraphColors('events');
        this.data = [
            {
                name: 'INFO',
                value: 0,
                iconClass: 'icon-okay',
                graph: [],
                title: this.$filter('translate')('dashboard.panel.events.status.info')
            },
            {
                name: 'WARNING',
                value: 0,
                iconClass: 'icon-warning',
                graph: [],
                title: this.$filter('translate')('dashboard.panel.events.status.warning')
            },
            {
                name: 'ERROR',
                value: 0,
                iconClass: 'icon-fail',
                graph: [],
                title: this.$filter('translate')('dashboard.panel.events.status.error')
            }
        ];
        this.renderCounter = 0;
    }

    $onInit() {
        this.updateData();
        this.destroyBroadcastCatcher = this.$rootScope.$on("subscriptionChanged", () => {
            this.updateData();
        });
    }

    $onDestroy() {
        this.destroyBroadcastCatcher();
    }

    updateData() {
        if (!this.widgetData) return;
        let bkpCtrlTime = this.widgetData.backupControllerTime,
            startBctrlTime = bkpCtrlTime || Date.now();

        this.startTime = startBctrlTime;
        this.data[0].value = _.reduce(this.widgetData.successCount, (sum, n) => sum + n, 0);
        this.data[1].value = _.reduce(this.widgetData.warningCount, (sum, n) => sum + n, 0);
        this.data[2].value = _.reduce(this.widgetData.failedCount, (sum, n) => sum + n, 0);

        this.data[0].graph = this.widgetData.successCount.map((element, index) => {
            return { y: element, x: startBctrlTime - index * (TIME_STEP) };
        });
        this.data[1].graph = this.widgetData.warningCount.map((element, index) => {
            return { y: element, x: startBctrlTime - index * (TIME_STEP) };
        });
        this.data[2].graph = this.widgetData.failedCount.map((element, index) => {
            return { y: element, x: startBctrlTime - index * (TIME_STEP) };
        });

        this.renderCounter++;
    }
}

EventsWidgetController.$inject = ['$scope', '$filter', '$rootScope', 'styleService', 'dashboardService', 'sharedPersistenceService'];

const eventsWidgetController = {
    controller: EventsWidgetController,
    template: require('./eventsWidget.template.html'),
    bindings: { widgetData: '<' },
};

module.exports = eventsWidgetController;



// WEBPACK FOOTER //
// ./src/azurebackup/views/dashboard/components/eventsWidget/eventsWidget.component.js